// src/access/access.ts

export const ACCESS_STORAGE_KEY = "dtf_wizard_access";
const LOCAL_DEV_TOKEN = "approved-access";

export function normalizeCode(code: string) {
  return code
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, ""); // removes dashes, spaces, anything not letters/numbers
}

export function hasAccess(): boolean {
  return localStorage.getItem(ACCESS_STORAGE_KEY) === LOCAL_DEV_TOKEN;
}

export function grantAccess(token: string): void {
  localStorage.setItem(ACCESS_STORAGE_KEY, token);
}

export function clearAccess(): void {
  localStorage.removeItem(ACCESS_STORAGE_KEY);
}

function isLocalhost(): boolean {
  return (
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  );
}

export async function tryGrantFromCode(
  rawCode: string | null | undefined
): Promise<boolean> {
  const code = normalizeCode(rawCode ?? "");

  // 🔥 LOCAL DEV BYPASS
  if (isLocalhost()) {
    if (code.length > 0) {
      grantAccess(LOCAL_DEV_TOKEN);
      return true;
    }
    return false;
  }

  // 🔒 PRODUCTION VALIDATION
  try {
    const response = await fetch("/.netlify/functions/redeem-code", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ code }),
    });

    const data = await response.json();

    if (response.ok && data?.success && data?.token) {
      grantAccess(data.token);
      return true;
    }

    return false;
  } catch (error) {
    console.error("Access validation failed:", error);
    return false;
  }
}